module.exports = __webpack_public_path__ + "static/media/GuestSuite.d34d0f72.jpg";